import styled from 'styled-components'
import { Typography } from '@healingpaper/cell'

import type { FC } from 'react'
import type { HospitalViewBadge } from '@/features/hospital/types/hospital.type'

interface ItemProps {
  badge: HospitalViewBadge
}
const HospitalBadgeView: FC<ItemProps> = ({ badge }) => {
  return (
    <HospitalBadgeStyle>
      <img src={badge?.badgeUrl} alt={badge?.badgeName} />
      <Typography elementType="h3" type="subTitle2">
        {badge?.badgeName}
      </Typography>
    </HospitalBadgeStyle>
  )
}

const HospitalBadgeStyle = styled.div`
  display: flex;
  align-items: center;
  & > img {
    width: 32px;
    height: 32px;
    margin-right: 8px;
  }
  & > div {
    p {
      margin-top: 4px;
    }
  }
`
interface ListProps {
  badges: HospitalViewBadge[]
  className?: string
}
const HospitalBadgeList: FC<ListProps> = ({ badges, className }) => {
  return (
    <div className={className}>
      {badges.map((badge) => {
        return (
          <div key={badge.badgeCode}>
            <HospitalBadgeView badge={badge} />
          </div>
        )
      })}
    </div>
  )
}

export default HospitalBadgeList
